import { ListItemIcon } from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import DevicesOtherIcon from "@material-ui/icons/DevicesOther";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { USER_GROUPS, checkRequiredPermissions } from "../../../Utils/Common";
import { showSidebar } from "../../../redux/actions/sidebarActions";

export default function Devices() {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  return checkRequiredPermissions([
    USER_GROUPS.ADMIN,
    USER_GROUPS.CLIENT,
    USER_GROUPS.SUPER_USER,
    USER_GROUPS.CLIENT_MAINTENANCE,
  ]) ? (
    <ListItem
      button
      onClick={() => {
        history.push("/devices");
        dispatch(showSidebar(false));
      }}
    >
      <ListItemIcon>
        <DevicesOtherIcon />
      </ListItemIcon>
      <ListItemText primary={t("mainSideBar.devices")} />
    </ListItem>
  ) : null;
}
